export const MODEL_ROUTE = '/identifying-access-tokens';
